/**
 * Routing.
 *
 * Turkish paths, because the URL is part of the interface. Every route that
 * exists leads to something real; there is no placeholder page for a feature
 * that has not been built.
 */

import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppShell } from "./AppShell";
import { NotFound } from "./NotFound";
import { HomeScreen } from "@/features/home/HomeScreen";
import { ProjectListScreen } from "@/features/projects/ProjectListScreen";
import { NewProjectScreen } from "@/features/projects/NewProjectScreen";
import { ProjectScreen } from "@/features/projects/ProjectScreen";
import { ProjectOverviewTab } from "@/features/projects/ProjectOverviewTab";
import { ProjectSessionsTab } from "@/features/sessions/ProjectSessionsTab";
import { ProjectCoverageTab } from "@/features/coverage/ProjectCoverageTab";
import { SessionScreen } from "@/features/sessions/SessionScreen";
import { ProjectReconstructionTab } from "@/features/reconstruction/ProjectReconstructionTab";
import { ProjectModelTab } from "@/features/reconstruction/ProjectModelTab";
import { ProjectFilesTab } from "@/features/reconstruction/ProjectFilesTab";
import { HelpScreen } from "@/features/support/HelpScreen";
import { RegionReviewScreen } from "@/features/coverage/RegionReviewScreen";
import { settingsRoute } from "@/features/support/settings/routes";
import { AboutScreen } from "@/features/support/AboutScreen";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <HomeScreen /> },
      { path: "projeler", element: <ProjectListScreen /> },
      { path: "projeler/yeni", element: <NewProjectScreen /> },
      {
        path: "projeler/:projectId",
        element: <ProjectScreen />,
        children: [
          { index: true, element: <ProjectOverviewTab /> },
          { path: "cekimler", element: <ProjectSessionsTab /> },
          { path: "kapsama", element: <ProjectCoverageTab /> },
          { path: "aci-kontrol", element: <RegionReviewScreen /> },
          { path: "rekonstruksiyon", element: <ProjectReconstructionTab /> },
          { path: "model", element: <ProjectModelTab /> },
          { path: "dosyalar", element: <ProjectFilesTab /> },
          // An unknown tab is a typo, not a missing page - send them to the
          // project rather than to a full-page 404.
          { path: "*", element: <Navigate to="." replace /> },
        ],
      },
      { path: "cekimler/:sessionId", element: <SessionScreen /> },
      { path: "yardim", element: <HelpScreen /> },
      settingsRoute,
      { path: "hakkinda", element: <AboutScreen /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
